import { Injectable } from '@angular/core';
import * as Leaflet from 'leaflet';

import {
  CircleShapeOptions,
  IsMarkerInShapeResp,
  PolygonShapeOptions,
} from '../interfaces';
import { MapShapeType } from '../constants/constants';

@Injectable({ providedIn: 'root' })
export class MarkerInShapesService {
  isMarkerInsideShape(
    event: Leaflet.DragEndEvent | Leaflet.LeafletMouseEvent,
    marker: Leaflet.Marker,
    shapeLayers: (Leaflet.Circle<unknown> | Leaflet.Polygon<unknown>)[],
    existingShapeTypes?: MapShapeType[]
  ): IsMarkerInShapeResp {
    const layersWithShapeInside = shapeLayers.filter((layer, index) => {
      switch (existingShapeTypes?.[index]) {
        case MapShapeType.Circle: {
          const circleLatLng = (layer as L.Circle).getLatLng();
          // mouse event
          if ('latlng' in event) {
            const e = event as L.LeafletMouseEvent;
            const clickLatLng = e.latlng;
            const distance = clickLatLng.distanceTo(circleLatLng);
            return distance < (layer as unknown as Leaflet.Circle).getRadius();
            // drag event
          } else {
            const marker = event.target as L.Marker;
            const markerLatLng = marker.getLatLng();
            const distance = markerLatLng.distanceTo(circleLatLng);
            return distance < (layer as unknown as Leaflet.Circle).getRadius();
          }
        }
        case MapShapeType.Polygon: {
          return this.isMarkerInsidePolygon(
            marker,
            layer as Leaflet.Polygon<unknown>
          );
        }
        default: {
          return false;
        }
      }
    });

    return {
      isInShape: !!layersWithShapeInside.length,
      shapeIds: layersWithShapeInside
        .map(
          shape =>
            (shape.options as CircleShapeOptions | PolygonShapeOptions).id
        )
        .filter(id => id) as (number | string)[],
    };
  }

  /** Ray casting algorithm */
  private isMarkerInsidePolygon(
    marker: Leaflet.Marker,
    shapeLayer: Leaflet.Polygon<unknown>
  ): boolean {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const polyPoints = (shapeLayer as any).getLatLngs()[0];
    const x = marker.getLatLng().lat,
      y = marker.getLatLng().lng;

    let inside = false;
    for (let i = 0, j = polyPoints.length - 1; i < polyPoints.length; j = i++) {
      const xi = polyPoints[i].lat,
        yi = polyPoints[i].lng;
      const xj = polyPoints[j].lat,
        yj = polyPoints[j].lng;

      const intersect =
        yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
      if (intersect) inside = !inside;
    }
    return inside;
  }
}
